enum PlayerType {
  Standard,
  Pitcher,
  DesignatedHitter,
}

export default PlayerType;
